import { BaseContainerModel } from '../../base-container.model';
import { bl_inv_stock_replenishment_run_category_RowClass } from '../../../dbschema/bl_inv_stock_replenishment_run_category.model';

export class StockReplenishmentRunFilterCategoryModel extends BaseContainerModel {
  bl_inv_stock_replenishment_run_category: bl_inv_stock_replenishment_run_category_RowClass = new bl_inv_stock_replenishment_run_category_RowClass();
}
